import * as React from 'react'
import { GridApiCommunity } from '../../../models/api/gridApiCommunity'
import { gridDensityRowHeightSelector } from '../density/densitySelector'

export function getMinimalContentHeight(
  apiRef: React.MutableRefObject<GridApiCommunity>
) {
  const rowHeight = gridDensityRowHeightSelector(apiRef)
  return 2 * rowHeight
}
